<div class="row">
    <div class="col-2 pt-2">
        <i class="icon {{message.icon}} fa-2x"></i>
    </div>
    <div class="col-10">
        <p class="m-0 pl-2 title"><strong>{{message?.title}}</strong></p>
        <p class="m-0 pl-2 message">{{message?.message}}</p>
    </div>
</div>
